<top-bar *ngIf="isLoggedIn$ | async"></top-bar>

<router-outlet></router-outlet>
